import { useEffect } from 'react';

import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { getFormalOffersMaxAvailableCash } from '@helpers/FormalOffers/getFormalOffersMaxAvailableCash';
import { tracking } from '@iwoca/frontend-tracking-library';
import { Card } from '@iwoca/orion';

import { ApprovalHeader } from '../ApprovalHeader';
import { ChooseAmount } from '../ChooseAmount';
import { ChooseDuration } from '../ChooseDuration';
import { TOfferSetType } from '../getOfferSetType';
import { NewLoanSummary } from '../NewLoanSummary/NewLoanSummary';
import { OfferTimeoutAlertBox } from '../OfferTimeoutAlertBox';
import { PageContainer } from '../PageContainer';

export const MoreFundsWithRepaymentChoice = ({
    timeoutDate,
    offerSetType,
    formalOffers,
    selectedOffer,
    setSelectedOffer,
    selectedAmount,
    setSelectedAmount,
    outstandingBalance
}: {
    timeoutDate: string;
    offerSetType: TOfferSetType;
    formalOffers: TFormalOffer[];
    selectedOffer: TFormalOffer | null;
    setSelectedOffer: (offer: TFormalOffer | null) => void;
    selectedAmount: number | null;
    setSelectedAmount: (amount: number) => void;
    outstandingBalance: number;
}) => {
    const maxAvailableCash = getFormalOffersMaxAvailableCash(formalOffers);

    useEffect(() => {
        tracking.ampli.approvedViewVisited({
            status: 'more_funds_with_repayment_choice'
        });
    }, []);

    return (
        <PageContainer data-testid="decision-approved">
            <Card className="space-y-xl min-l:p-xl">
                <OfferTimeoutAlertBox timeoutDate={timeoutDate} />
                <ApprovalHeader offerSetType={offerSetType} />
                <ChooseAmount
                    selectedAmount={selectedAmount}
                    setSelectedAmount={setSelectedAmount}
                    maxAmount={maxAvailableCash}
                />
                <ChooseDuration
                    offers={formalOffers}
                    selectedOffer={selectedOffer}
                    setSelectedOffer={setSelectedOffer}
                />
            </Card>
            <NewLoanSummary
                selectedAmount={selectedAmount}
                selectedOffer={selectedOffer}
                outstandingBalance={outstandingBalance}
            />
        </PageContainer>
    );
};
